import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector, APP_INITIALIZER, Injectable, Component, Compiler, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { RouteNavigationService, configServiceFactory } from './services/dynamic-routes-loader/route-navigation.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpHeaders, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { SemNavigationModule } from '../app/navigation/modules/sem-navigation/sem-navigation.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, UrlSerializer } from '@angular/router';
import { PROJECT_ROUTES } from './project/project.routes';
import { SemDynamicComponent } from './shared/components/sem-dynamic/sem-dynamic.component';
import { CustomUrlSerializer } from './shared/helpers/custom-url-serializer';
import { SemLoaderComponent } from './shared/components/sem-loader/sem-loader.component';
import { SemDateFormatPipePipe } from './shared/helpers/pipes/sem-date-format-pipe.pipe';
import { SemDashboardContainerComponent } from './components/containers/sem-dashboard-container/sem-dashboard-container.component';
import { NavigationRequestModel } from './models/navigation/navigation-request-model';
import { ErrorsHandler } from './errorshandler';
import { ServerErrorsInterceptor } from './server-errors.interceptor';
import { SemNotFoundComponent } from './components/containers/sem-not-found/sem-not-found.component';
import { SemConfirmDialogComponent } from './components/controls/dialogs/sem-confirm-dialog/sem-confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SemSearchFieldsDialogComponent } from './components/controls/dialogs/sem-search-fields-dialog/sem-search-fields-dialog.component';
import { SemGridDisplayFieldsDialogComponent } from './components/controls/dialogs/sem-grid-display-fields-dialog/sem-grid-display-fields-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WindowRefService } from './services/window-ref.service';
import { NotificationCenterComponent } from './components/containers/notification-center/notification-center/notification-center.component';
import { BulkImportComponent } from './components/containers/bulk-import/bulk-import.component';
import { ContainerWrapperComponent } from './components/containers/container-wrapper/container-wrapper/container-wrapper.component';
import { WgMetadataPanelComponent } from './navigation/components/wg-metadata-panel/wg-metadata-panel.component';
import { WgAiPanelComponent } from './navigation/components/wg-ai-panel/wg-ai-panel.component';
import { SemSharedModule } from './shared/modules/sem-shared/sem-shared.module';
//import { NgSelectComponent } from '@ng-select/ng-select';
import { SemVersionDialogComponent } from './components/controls/dialogs/sem-version-dialog/sem-version-dialog.component';
import { SemParameterDialogComponent } from './components/controls/dialogs/sem-parameter-dialog/sem-parameter-dialog.component';
import { SemQuickCreateFormDialogComponent } from './components/controls/dialogs/sem-quick-create-form-dialog/sem-quick-create-form-dialog.component';
import { AuthGuardService } from './services/guards/auth/auth-guard.service';
import { SemCompareDialogComponent } from './components/controls/dialogs/sem-compare-dialog/sem-compare-dialog.component';
import { SemActionComponent } from './components/controls/sem-action/sem-action.component';
import { WorkflowCenterComponent } from './components/containers/workflow-center/workflow-center.component';
import { SemUserProfileDialogComponent } from './components/controls/dialogs/sem-user-profile-dialog/sem-user-profile-dialog.component';
import { SemDailyChallengeDialogComponent } from './components/controls/dialogs/sem-daily-challenge-dialog/sem-daily-challenge-dialog.component';
import { SemMinMaxDirective } from './directives/validators/sem-min-max.directive';
import { WgPanelManagerDirective } from './directives/wg-panel-manager/wg-panel-manager.directive';
import { LoginComponent } from './components/login/login.component';
import { PlatformRedirectComponent } from './platform-redirect/platform-redirect.component';
import { environment } from '../environments/environment';

import { NgxPhotoEditorModule } from "ngx-photo-editor";
//import { MatTooltipModule } from '@angular/material/tooltip';

import localeSl from '@angular/common/locales/sl';
import { SemViewSettingsDialogComponent } from './components/controls/dialogs/sem-view-settings-dialog/sem-view-settings-dialog.component';
import { SemTagsInputComponent } from './components/controls/sem-tags-input/sem-tags-input.component';
import { NgxCurrencyDirective } from "ngx-currency";
import { ComponentRegistryService } from './services/dynamic-compilation/component-registry.service';
import { initializeComponentRegistry } from './services/dynamic-compilation/component-registry.initializer';
import { SemServerUnavailableComponent } from './components/containers/sem-server-unavailable/sem-server-unavailable.component';


// Register the Slovenian locale data
registerLocaleData(localeSl);

@NgModule({ declarations: [
        AppComponent,
        SemDynamicComponent,
        SemDateFormatPipePipe,
        SemDashboardContainerComponent,
        SemNotFoundComponent,
        SemConfirmDialogComponent,
        SemConfirmDialogComponent,
        SemSearchFieldsDialogComponent,
        SemGridDisplayFieldsDialogComponent,
        NotificationCenterComponent,
        ContainerWrapperComponent,
        SemVersionDialogComponent,
        SemParameterDialogComponent,
        SemQuickCreateFormDialogComponent,
        SemCompareDialogComponent,
        WorkflowCenterComponent,
        SemUserProfileDialogComponent,
        SemDailyChallengeDialogComponent,
        SemMinMaxDirective,
        WgPanelManagerDirective,
        LoginComponent,
        PlatformRedirectComponent,
        SemViewSettingsDialogComponent,
        SemServerUnavailableComponent,
    ],
    exports: [
        SemConfirmDialogComponent,
        SemSearchFieldsDialogComponent,
        //MatTooltipModule,
        SemGridDisplayFieldsDialogComponent,
        DragDropModule,
        SemSharedModule,
        NgxPhotoEditorModule,
        SemParameterDialogComponent,
        SemQuickCreateFormDialogComponent,
        SemCompareDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        WgMetadataPanelComponent,
        WgAiPanelComponent,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        CommonModule,
        MatDialogModule,
        DragDropModule,
        ScrollingModule,
        SemNavigationModule,
        //MatTooltipModule,
        SemSharedModule,
        NgxPhotoEditorModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'account/login', pathMatch: 'full' },
            {
                path: "",
                component: AppComponent,
                data: {
                    breadcrumb: 'main'
                }
            },
            {
                path: "platform",
                component: PlatformRedirectComponent
            },
            {
                path: "account/login",
                component: LoginComponent,
                data: { breadcrumb: 'login' }
            },
            {
                path: "cms",
                component: ContainerWrapperComponent,
                data: {
                    breadcrumb: 'main'
                },
                children: [
                    {
                        path: 'notificationcenter',
                        component: NotificationCenterComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            breadcrumb: 'galis_js_ActionCenter'
                        },
                    },
                    {
                        path: 'workflowcenter',
                        component: WorkflowCenterComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            breadcrumb: 'galis_js_ActionCenter'
                        },
                    },
                    {
                        // The bulk-import wizard. Reached three ways, all through this one route:
                        // bare (lands on the model picker), with ?model=<FullName> (skips to the
                        // file step), and from the dbo.navigationnode entries registered by
                        // Application/Bulk/Sql/register-navigation-models.sql. The bare form is the
                        // fallback path and must keep working.
                        path: 'bulk-import',
                        component: BulkImportComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            breadcrumb: 'galis_js_BulkImport'
                        },
                    },
                    // App pages (module Client/Project), empty in core
                    ...PROJECT_ROUTES,
                    {
                        path: 'server-unavailable',
                        component: SemServerUnavailableComponent,
                        data: { breadcrumb: 'unavailable' }
                    },
                ]
            }
        ], { onSameUrlNavigation: 'reload' })], providers: [
        RouteNavigationService, SemLoaderComponent, SemDateFormatPipePipe, WindowRefService,
        {
            provide: APP_INITIALIZER,
            useFactory: configServiceFactory,
            deps: [Injector, RouteNavigationService], multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeComponentRegistry,
            deps: [ComponentRegistryService],
            multi: true
        },
        {
            provide: UrlSerializer,
            useClass: CustomUrlSerializer
        },
        NavigationRequestModel,
        /*{
          provide: ErrorHandler,
          useClass: ErrorsHandler,
        },*/
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ServerErrorsInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        // Angular 21 defaults to zoneless change detection; this codebase relies throughout
        // on classic zone.js-driven auto-CD (imperative field mutations inside subscribe()
        // callbacks with no signals/markForCheck). Without this, NgZone never wires into
        // Angular's scheduler, so views only repaint on the next Angular-bound DOM event.
        provideZoneChangeDetection({ eventCoalescing: true })] })
export class AppModule { }
